var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-start"},_vm._l((_vm.templates),function(template,index){return _c('download-custom-document-button',{key:index,staticClass:"px-0",attrs:{"order":_vm.order,"checkbox-services-selected":_vm.checkboxServicesSelected,"template":template}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }